const PERM_KEY = 'poupix_cam_perm';

let _stream = null;
let _acquiring = null;

export async function acquireStream(constraints) {
  if (_stream && _stream.getVideoTracks().every(t => t.readyState === 'live')) {
    return _stream;
  }
  if (_acquiring) return _acquiring;

  _acquiring = navigator.mediaDevices.getUserMedia(constraints)
    .then(stream => {
      _stream = stream;
      try { localStorage.setItem(PERM_KEY, 'granted'); } catch (_) {}
      return stream;
    })
    .catch(err => {
      if (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError') {
        try { localStorage.setItem(PERM_KEY, 'denied'); } catch (_) {}
      }
      throw err;
    })
    .finally(() => { _acquiring = null; });

  return _acquiring;
}

export function releaseStream() {
  if (_stream) {
    _stream.getTracks().forEach(t => t.stop());
    _stream = null;
  }
  _acquiring = null;
}

export function isStreamLive() {
  return !!(_stream && _stream.getVideoTracks().some(t => t.readyState === 'live'));
}

export async function getPermissionState() {
  try {
    const result = await navigator.permissions.query({ name: 'camera' });
    return result.state;
  } catch (_) {
    try { return localStorage.getItem(PERM_KEY) || 'unknown'; } catch (_) {}
    return 'unknown';
  }
}
